import React, { useEffect, useState } from 'react'
import getServiceClauseService from 'services/article/getServiceClause'
import { useDispatch } from 'react-redux'
import DOMPurify from 'dompurify'
import styles from 'layouts/appView/layout.module.sass'

function ServiceClause() {
  const dispatch = useDispatch()
  const [content, setContent] = useState('')

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await dispatch(getServiceClauseService())
        setContent(DOMPurify.sanitize(data.content))
      } catch (error) {
        //
      }
    }
    fetchData()
  }, [dispatch])

  return (
    <div
      className={styles.innerHtml}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}

export default ServiceClause
